var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pdf-block',{attrs:{"src":_vm.url,"page":_vm.pageNum},on:{"num-pages":function($event){_vm.pageTotalNum=$event}}}),_c('button',{on:{"click":_vm.prePage}},[_vm._v("上一页")]),_c('button',{on:{"click":_vm.nextPage}},[_vm._v("下一页")]),_c('span',[_vm._v(_vm._s(_vm.pageNum)+" / "+_vm._s(_vm.pageTotalNum))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }